import styled from "styled-components";
import { colors } from "../../helpers/functions";

export const MenuNavStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgb(240,236,201);
    background: linear-gradient(0deg, rgba(240,236,201,0.50) 0%, rgba(240,236,201,1) 100%);
    ul{
        width: 80vw;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        list-style: none;
        margin: 0;
        padding: 0;
        margin-top: 10vw;
        //background-color: blueviolet;
        li{
            background-color: rgba(${colors.azul_agua}, .95);//rgba(0, 0, 0, 0.25);
            margin-bottom: 10px;
            padding: 10px 20px;
            p{
                text-align: center;
                margin: 0;
                font-weight: 800;
                font-size: 22px;
                line-height: 24px;
                text-transform: uppercase;
                color: rgba(${colors.blanco_huevo}, 1)
            }
            &:last-child{
                margin-bottom: 0;
            }
        }
    }

    .slideInDown {
        -webkit-animation-name: slideInDown;
        animation-name: slideInDown;
        -webkit-animation-duration: 0.5s;
        animation-duration: 0.5s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        &.delay1{
            animation-delay: 0.05s;
        }
        &.delay2{
            animation-delay: 0.1s;
        }
        &.delay3{
            animation-delay: 0.15s;
        }
        &.delay4{
            animation-delay: 0.20s;
        }
        &.delay5{
            animation-delay: 0.25s;
        }
    }
    @-webkit-keyframes slideInDown {
        0% {
            -webkit-transform: translateY(-100%);
            transform: translateY(-100%);
            opacity: 0;
            visibility: visible;
        }
        100% {
            opacity: 1;
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
    }

    @keyframes slideInDown {
        0% {
            opacity: 0;
            -webkit-transform: translateY(-100%);
            transform: translateY(-100%);
            visibility: visible;
        }
        100% {
            opacity: 1;
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
    } 
`

